import angular from 'angular';
import { getZendeskUrl } from '@/shared/components/ZendeskHelp';

angular
  .module('cxSettings')
  .controller('EmailDomainCnameInfoDialogCtrl', [
    '$element',
    '$http',
    'appUrls',
    'flySvc',
    'close',
    'dataCache',
    '$translate',
    'ModalService',
    'emailDomain',
    'companyId',
    emailDomainCnameInfoDialogCtrl,
  ]);

function emailDomainCnameInfoDialogCtrl(
  $element,
  $http,
  appUrls,
  flySvc,
  close,
  dataCache,
  $translate,
  ModalService,
  emailDomain,
  companyId,
) {
  var vm = this;
  vm.emailDomain = emailDomain;

  vm.emailDomainResponse = undefined;

  vm.zendeskUrl = getZendeskUrl('5434786772242', $translate.use());

  vm.verify = function() {
    vm.verifying = true;
    vm.emailDomainResponse = undefined;

    $http({
      method: 'get',
      url: appUrls.api + '/api/settings/VerifyEmailDomain?id=' + companyId,
    })
      .then(function(response) {
        var result = response.data;
        vm.emailDomainResponse = result;
      })
      .catch(function(error) {
        flySvc.error(error.code, error.parameters);
      })
      .finally(function() {
        vm.verifying = false;
      });
  };

  vm.openEmailEditor = function() {
    ModalService.showModal({
      template: require('./mailEmailDomainCnameInfoDialog.html'),
      controller: 'MailEmailDomainCnameInfoDialogCtrl',
      controllerAs: 'vm',
      locationChangeSuccess: false,
      inputs: {
        companyId: companyId,
      },
    }).then(function(modal) {
      modal.element.modal();
      modal.element.on('hidden.bs.modal', function(e) {
        modal.element.off(e); //Remove event
        modal.element.remove(); //Remove element
      });
    });
  };

  vm.cancel = function() {
    close(vm.emailDomainResponse, 500);
  };
}
